<div *ngFor="let msg of messages()"
     [ngClass]="{'alert-danger': msg.level.value === 'error', 'alert-warning': msg.level.value === 'warning', 'alert-info': msg.level.value === 'info'}"
     class="alert alert-dismissible">
  <button class="btn-close" data-bs-dismiss="alert" type="button"></button>
  <span *ngIf="msg.level.value == 'error'"><strong>Error!</strong>&nbsp;{{ msg.text }}</span>
  <span *ngIf="msg.level.value == 'warning'"><strong>Warning!</strong>&nbsp;{{ msg.text }}</span>
  <span *ngIf="msg.level.value == 'info'"><strong>Info!</strong>&nbsp;{{ msg.text }}</span>
</div>
